import { useEffect, useRef, useState } from 'react';
import './Projects.css';

const projects = [
    {
        number: '01',
        title: 'My Hype',
        description: 'Projeto PAP do Curso Profissional. Desenvolvimento de uma loja online de sapatilhas com sistema de catálogo, carrinho de compras e gestão de utilizadores.',
        tags: ['HTML', 'CSS', 'JavaScript', 'PHP', 'SQL'],
        link: 'https://alpha.soaresbasto.pt/~a28841/PAP/Website/',
    },
    {
        number: '02',
        title: 'InstantRent',
        description: 'Projeto final do CTeSP em Desenvolvimento de Software (ESAN). Plataforma web e aplicação mobile para aluguer de veículos com gestão de reservas, autenticação e backoffice administrativo.',
        tags: ['PHP', 'SQL', 'JavaScript', 'Android', 'API'],
        link: '#',
    },
    {
        number: '03',
        title: 'Portfolio Pessoal',
        description: 'Website desenvolvido em React para apresentação dos meus projetos, competências e percurso académico.',
        tags: ['React', 'JavaScript', 'CSS'],
        link: 'https://springgreen-vulture-995166.hostingersite.com/?LSCWP_CTRL=before_optm&nocache=1771978686996',
    },
    {
        number: '04',
        title: 'Mundo Teckel',
        description: 'Website informativo desenvolvido em React para um criador de Teckel.',
        tags: ['React', 'JavaScript', 'CSS', 'Responsive Design'],
        link: 'https://moccasin-hornet-217537.hostingersite.com',
    },
    {
        number: '05',
        title: 'IdealVista',
        description: 'Website desenvolvido para uma imobiliária, com apresentação de imóveis, filtros de pesquisa e interface moderna e responsiva.',
        tags: ['Next.js', 'JavaScript', 'SQL', 'CSS', 'Responsive Design'],
        status: 'Em Desenvolvimento',
        link: 'https://deepskyblue-dunlin-530836.hostingersite.com',
    },
    {
        number: '06',
        title: 'AutoStand',
        description: 'Website stand automóvel, desenvolvido como projeto pessoal para reforço de competências em desenvolvimento web.',
        tags: ['Next.js', 'JavaScript', 'Supabase', 'CSS', 'Responsive Design'],
        status: 'Em Desenvolvimento',
        link: 'https://autostand.vercel.app',
    },
];

export default function Projects({ id }) {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [lineVisible, setLineVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setLineVisible(true), 100);
                    setTimeout(() => setVisible(true), 300);
                }
            },
            { threshold: 0.1 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="projects-container" id={id} ref={sectionRef}>

            <div className={`section-label ${visible ? 'section-label--visible' : ''}`}>
                <span>04</span>
                <span>PROJETOS</span>
            </div>

            <div className={`section-line ${lineVisible ? 'section-line--visible' : ''}`} />

            <div className="projects-header">
                <h2 className={`section-title ${visible ? 'section-title--visible' : ''}`}>
                    <span>Trabalho</span>
                    <span className="text-outline">realizado.</span>
                </h2>
            </div>

            <div className="projects-list">
                {projects.map((project, i) => (
                    <a
                        href={project.link}
                        target='_blank'
                        rel="noreferrer"
                        key={project.number}
                        className={`project-item ${visible ? 'project-item--visible' : ''}`}
                        style={{ transitionDelay: `${0.2 + i * 0.15}s` }}
                    >
                        <div className="project-number">{project.number}</div>

                        <div className="project-info">


                            <div className='project-top'>
                                <h3 className="project-title">{project.title}</h3>
                                {project.status && (
                                    <span className="project-status">{project.status}</span>
                                )}
                            </div>
                            <p className="project-description">{project.description}</p>
                            <div className="project-tags">
                                {project.tags.map(tag => (
                                    <span key={tag} className="pill">{tag}</span>
                                ))}
                            </div>
                        </div>

                        <div className="project-arrow">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M7 17L17 7M17 7H7M17 7V17" />
                            </svg>
                        </div>
                    </a>
                ))}
            </div>

            <div className={`section-line section-line--bottom ${lineVisible ? 'section-line--visible' : ''}`} />
        </div>
    );
}